import * as detective from 'eos-detective'

const apiEndpoint = 'https://graph-api.eosdetective.io/v0'

const apiCall = ({ apiToken, endpoint, method, data, params }) => new Promise((resolve, reject) => {
  detective.config(apiToken, { endpoint: apiEndpoint })

  if (endpoint === 'accounts') {
    detective.accounts(params.type)
      .then((data) => { resolve(data.data) })
      .catch(error => reject(error.error))
  }
  if (endpoint === 'transfers') {
    detective.transfers(params.accounts, params.params)
      .then(data => resolve(data.data))
      .catch(error => reject(error.error))
  }
  if (endpoint === 'profile') {
    detective.profile(params.account)
      .then(data => resolve(data.data))
      .catch(error => reject(error.error))
  }
  if (endpoint === 'stats') {
    detective.stats(params)
      .then((data) => { resolve(data.data) })
      .catch(error => reject(error.error))
  }
})

export default apiCall
